module.exports = {
  //Common Button
  CUR_COMMON__ACADEMICS_YEAR: 'Academic Year',
  CUR_COMMON__ADD: 'Add',
  CUR_COMMON__ADD_SUBDATA: 'Add Sub-Data',
  CUR_COMMON__ADDITIONAL: 'Additional',
  CUR_COMMON__ATTACH_FILES: ' Attach Files',
  CUR_COMMON__BACK: 'Back',
  CUR_COMMON__BRIEF: 'Brief',
  CUR_COMMON__CANCEL: 'Cancel',
  CUR_COMMON__CANCEL_EDIT: 'Cancel Editing',
  CUR_COMMON__CAMPUS: 'Campus',
  CUR_COMMON__CATEGORY: 'Category',
  CUR_COMMON__CLEAN_UP: 'Clean up',
  CUR_COMMON__CONFIRM: 'Confirm',
  CUR_COMMON__CONFIRM_DELETE_DATA: 'Confirm delete data ?',
  CUR_COMMON__CONFIRM_DELETE_DATA_DESC: 'You want to confirm data deletion.',
  CUR_COMMON__CONFIRM_TRANSACTION: 'Confirm a transaction',
  CUR_COMMON__CONFIRM_TRANSACTION_DESC: 'Do you want to confirm the transaction?',
  CUR_COMMON__COPY: 'Copy',
  CUR_COMMON__DATA_NOT_FOUND: 'Data not found',
  CUR_COMMON__DECLARATION_OF_USE: 'Declaration of use',
  CUR_COMMON__DELETE: 'Delete',
  CUR_COMMON__DELETE_DATA: 'Delete Data !',
  CUR_COMMON__DEPARTMENT: 'Department',
  CUR_COMMON__DETAILS: 'Details',
  CUR_COMMON__DOWNLOAD: 'Download',
  CUR_COMMON__EDIT: 'Edit',
  CUR_COMMON__EDIT_SUCCESSFULLY: 'You have successfully edited',
  CUR_COMMON__EDIT_SUCCESSFULLY_DESC: 'Subject editing has been recorded',
  CUR_COMMON__EDUCATION_LEVEL: 'Education Level',
  CUR_COMMON__FACULTY: 'Faculty',
  CUR_COMMON__FILES_SIZE_NO_LARGER_THAN_2MB: 'Each individual file must be no larger than 2 MB',
  CUR_COMMON__FILES_TYPE: 'Files Type',
  CUR_COMMON__IMPORT_FILES: 'Import Files',
  CUR_COMMON__INVALID_DATA: ' Invalid data ,Please check again.',
  CUR_COMMON__ITEMS: 'Items',
  CUR_COMMON__MAJOR: 'Major',
  CUR_COMMON__NEXT: 'Next',
  CUR_COMMON__OBJECTIVE: 'Objective',
  CUR_COMMON__OFFER: 'Offer to consider',
  CUR_COMMON__PLEASE_SELECT: 'Please Select',
  CUR_COMMON__RESET: 'Reset',
  CUR_COMMON__RECORD_STATUS_ACTIVE: 'Active',
  CUR_COMMON__RECORD_STATUS_INACTIVE: 'Inactive',
  CUR_COMMON__SAVE: 'Save',
  CUR_COMMON__SAVE_SUCCESSFULLY: 'Saved Successfully !',
  CUR_COMMON__SEARCH: 'Search',
  CUR_COMMON__SELECT: 'Select',
  CUR_COMMON__SETTING: 'Setting',
  CUR_COMMON__SPECIFY_CAMPUS: 'Select Campus',
  CUR_COMMON__SPECIFY_DEPARTMENT: 'Select Department',
  CUR_COMMON__SPECIFY_EDUCATION_LEVEL: 'Select Education Level',
  CUR_COMMON__SPECIFY_FACULTY: 'Select Faculty',
  CUR_COMMON__SPECIFY_MAJOR: 'Select Major',
  CUR_COMMON__STATUS: 'Status',
  CUR_COMMON__STATUS_ITEMS: 'Status',
  CUR_COMMON__SUBMENU: 'Sub Menu',
  CUR_COMMON__SUBTRACT: 'Subtract',
  CUR_COMMON__SUCCESSFUL_STATUS: 'Successful !',
  CUR_COMMON__SUCCESSFUL_STATUS_DESC: 'you have completed the transaction',
  CUR_COMMON__SELECT_ALL: ' Select All',
  CUR_COMMON__SOMETHING_WRONG: 'Something went wrong !',
  CUR_COMMON__SOMETHING_WRONG_DESC: 'Sorry something went wrong, try again later',
  CUR_COMMON__TRASACTION_SAVED: 'the transaction has been saved',
  CUR_COMMON__TOTAL: 'Total',
  CUR_COMMON__UPDATED_DT: 'Updated Date',
  CUR_COMMON__VIEW: 'View',
  //Subject
  CUR_SUBJECT_DATA__ADD_SUBJECT: 'Add Subject',
  CUR_SUBJECT_DATA__APPROVED_DATE: 'Approved Date',
  CUR_SUBJECT_DATA__CREDIT: 'Credit',
  CUR_SUBJECT_DATA__DELETED: 'Subject data has been deleted',
  CUR_SUBJECT_DATA__DIFFRENCE_CREDIT: 'Difference in Credits and Frequency in Course Structure',
  CUR_SUBJECT_DATA__MIN_CREDIT: 'Minimum Credits for Registration Requirements',
  CUR_SUBJECT_DATA__NUMBER_REGISTRATION: 'Number of Registrations Required',
  CUR_SUBJECT_DATA__OBJECTIVE: 'Objective of Opening/Improving Subject',
  CUR_SUBJECT_DATA__STATUS: 'Subject Status',
  CUR_SUBJECT_DATA__SHOW_HOUR: 'Expressing Units as Hours',
  CUR_SUBJECT_DATA__SPLIT_REGISTRATION: 'Subjects that can be divided by Credit for Registration',
  CUR_SUBJECT_DATA__START_YEAR: 'Year of Subject Opening',
  CUR_SUBJECT_DATA__SPECIFY_START_YEAR: 'Select Year of Subject Opening',
  CUR_SUBJECT_DATA__SUBJECT_CATEGORY: 'Subject Category',
  CUR_SUBJECT_DATA__SPECIFY_SUBJECT_CATEGORY: 'Select Subject Category',
  CUR_SUBJECT_DATA__SUBJECT_CODE: 'Subject Code',
  CUR_SUBJECT_DATA__SPECIFY_SUBJECT_CODE: 'Select Subject Code',
  CUR_SUBJECT_DATA__SUBJECT_DESCRIPTION_EN: 'Subject Description (EN)',
  CUR_SUBJECT_DATA__SUBJECT_DESCRIPTION_TH: 'Subject Description (TH)',
  CUR_SUBJECT_DATA__SUBJECT_NAME: 'Subject Name',
  CUR_SUBJECT_DATA__SUBJECT_NAME_EN: 'Subject Name (EN)',
  CUR_SUBJECT_DATA__SUBJECT_NAME_TH: 'Subject Name (TH)',
  CUR_SUBJECT_DATA__SPECIFY_SUBJECT_NAME_EN: 'Specify Subject Name in English',
  CUR_SUBJECT_DATA__SPECIFY_SUBJECT_NAME_TH: 'Specify Subject Name in Thai',
  CUR_SUBJECT_DATA__SUBJECT_SHOW_CODE: 'Subject Show Code on the Score Report (Transcript)​',
  CUR_SUBJECT_DATA__SPECIFY_SUBJECT_SHOW_CODE: 'Select Subject Show Code',
  CUR_SUBJECT_DATA__SUBJECT_TYPE: 'Subject Type',
  CUR_SUBJECT_DATA__SPECIFY_SUBJECT_TYPE: 'Select Subject Type',
  CUR_SUBJECT_DATA__TEACHER: 'Teacher in charge of the subject',
  CUR_SUBJECT_DATA__SPECIFY_TEACHER: 'Specify Teacher Code or Teacher Name',
  CUR_SUBJECT_DATA__TQF_TYPE: 'TQF Type',
  CUR_SUBJECT_DATA__SPECIFY_TQF_TYPE: 'Select TQF Type',
  CUR_SUBJECT_DATA__SUBJECT_DETAILS: 'Subject Details',
  CUR_SUBJECT_DATA__DETERMINE_PRE_CO_HOUR: 'Determine Pre-Co Subjects / Teaching Hours ',
  CUR_SUBJECT_DATA__DETERMINE_PRE_CO: 'Determine Pre-requisite and Co-requisite',
  CUR_SUBJECT_DATA__PRE_REQUISTED: 'Pre-requisite subjects',
  CUR_SUBJECT_DATA__CO_REQUISTED: 'Co-requisite subjects',
  CUR_SUBJECT_DATA__DETERMINE_HOUR: 'Determine Teaching Hours ',
  CUR_SUBJECT_DATA__TEACHING_HOURS_DETAILS: 'Teaching Hours Details',
  CUR_SUBJECT_DATA__ADD_GROUP: 'Add Group',
  CUR_SUBJECT_DATA__DELETE_GROUP: 'Delete Group',
  CUR_SUBJECT_DATA__ALERT_PRE_REQUISTED: 'The group of subjects that must be taken before being able to register for a course',
  CUR_SUBJECT_DATA__ALERT_CO_REQUISTED: 'The group of subjects that must be taken concurrently in order to be able to register for a course ',
  CUR_SUBJECT_DATA__ADD_PRE_REQUISTED: 'Add Pre-requisted',
  CUR_SUBJECT_DATA__ADD_CO_REQUISTED: 'Add Co-requisted',
  CUR_SUBJECT_DATA__ADD_TEACHING_HOURS_DETAILS: 'Add Teaching hours details',
  CUR_SUBJECT_DATA__ADD_STRATEGIC_OF_UNIVERSITY: 'Add University Strategic Plan Goals ',
  CUR_SUBJECT_DATA__TOPIC_DETAILS: 'Topic Details',
  CUR_SUBJECT_DATA__THEORETICAL_HOURS: 'Theoretical Hours',
  CUR_SUBJECT_DATA__PRACTICAL_HOURS: 'Practical Hours  ',
  CUR_SUBJECT_DATA__SPECIFY_DETAILS: 'Details',
  CUR_SUBJECT_DATA__SPECIFY_HOURS: 'Hours',
  CUR_SUBJECT_DATA__NO: 'NO.',
  CUR_SUBJECT_DATA__LIST: 'List',
  CUR_SUBJECT_DATA__EXAMINATION_FORMAT: 'Examination-based learning format',
  CUR_SUBJECT_DATA__SPECIFY_FORMAT: 'Select a format',
  CUR_SUBJECT_DATA__SPECIFY_GOALS: 'Select Goals',
  CUR_SUBJECT_DATA__STRATEGIC_OF_UNIVERSITY: 'University Strategic Plan Goals ',
  CUR_SUBJECT_DATA__ACHIEVEMENT_GOALS: ' achievement of the subject goals ',
  CUR_SUBJECT_DATA__RESPONSIVE_TO_ACHIEVEMENT: 'courses can be designed to be responsive and contribute to the achievement of strategic goals',
  CUR_SUBJECT_DATA__SPECIFY_CLO: 'Specify the expected of course learning outcomes',
  CUR_SUBJECT_DATA__SPECIFY_PLO: 'Specify the expected of program learning outcomes',
  CUR_SUBJECT_DATA__SPECIFY_NUMBER: 'Specify numerical terms',
  CUR_SUBJECT_DATA__SPECIFY_OBJECTIVE: 'Specify objective of opening/improving subject',
  CUR_SUBJECT_DATA__SPECIFY_DESCRIPTION_TH: 'Specify subject description in Thai',
  CUR_SUBJECT_DATA__SPECIFY_DESCRIPTION_EN: 'Specify subject description in English',
  CUR_SUBJECT_DATA__CAN_DEVIDE_CREDIT: 'Can be divided',
  CUR_SUBJECT_DATA__CANT_DEVIDE_CREDIT: 'Cannot be divided',
  CUR_SUBJECT_DATA__TITLE: 'General information',
  CUR_SUBJECT_DATA__SPECIFY_SUBJECT: 'Specify Subject Code or Subject Name',
  CUR_SUBJECT_DATA__EDIT_INFORMATION: 'Edit the basic information of the subject.  ',
  CUR_SUBJECT_DATA__COPY_TITLE: 'Confirm the subject to duplicate',
  CUR_SUBJECT_DATA__SUBJECTCODE_YEAR: 'Subject-Year',
  CUR_SUBJECT_DATA__SEARCH_RESULTS: 'Search Results',
  CUR_SUBJECT_DATA__SELECT_PRE_REQUIST: 'Search Pre-requist',
  CUR_SUBJECT_DATA__SELECT_CO_REQUIST: 'Search Co-requist',
  CUR_SUBJECT_DATA__ENTER_KEYWORD: 'Please enter a keyword to search.!',
  CUR_SUBJECT_DATA__INFORMTION_INCOMPLETE: 'Subject information is incomplete.',
  CUR_SUBJECT_DATA__INFORMTION_INCOMPLETE_DESC: 'Do you want to complete the information?',
  CUR_SUBJECT_DATA__CREATED_SUCCESSFULLY: 'Created subject successfully',
  CUR_SUBJECT_DATA__DUPLICATE_SUBJECT_CODE: 'Duplicate subject code',
  CUR_SUBJECT_DATA__DUPLICATE_SUBJECT_CODE_DESC: 'Duplicate subject code, Please enter a new code!',
}
